import { Component, ChangeDetectionStrategy, ViewChild, inject, computed, DestroyRef, effect } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { tap } from 'rxjs/operators';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { isNil } from 'lodash';
import { IrisDmsTrashBinStore } from '@iris/common/modules/dms/store/trash-bin.signal-store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { StrakitCheckboxComponent } from '@ngx-strakit/cdk/controls';
@Component({
  selector: 'dms-grid-trash-bin-checkbox-header-template',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,

    MatMenuModule,

    StrakitCheckboxComponent,
  ],
  templateUrl: './dms-grid-trash-bin-checkbox-header-template.component.html',
  styleUrls: ['./dms-grid-trash-bin-checkbox-header-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridTrashBinCheckboxHeaderTemplateComponent implements IHeaderAngularComp {
  private readonly destroyRef = inject(DestroyRef);

  private readonly dmsTrashBinStore = inject(IrisDmsTrashBinStore);

  readonly valueControl = new FormControl(false);

  private readonly selectedItemsCount = this.dmsTrashBinStore.selectedRowsCount;
  private readonly totalItemsCount = this.dmsTrashBinStore.paginationCount;

  public readonly hasAnySelection = computed(() => this.selectedItemsCount() > 0);
  public readonly selected = computed(() => this.hasAnySelection() && this.selectedItemsCount() === this.totalItemsCount());
  public readonly indeterminate = computed(() => this.hasAnySelection() && this.selectedItemsCount() < this.totalItemsCount());

  @ViewChild(MatMenuTrigger) selectionMenu: MatMenuTrigger;

  readonly controlEffect = effect(() => {
    this.valueControl.patchValue(this.selected(), { emitEvent: false });
  });

  agInit(): void {
    this.valueControl.valueChanges.pipe(
      tap(() => this.checkboxClicked()),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  refresh(): boolean {
    return true;
  }

  checkboxClicked(): void {
    this.valueControl.patchValue(false, { emitEvent: false });
    if (!this.hasAnySelection()) {
      this.selectionMenu.openMenu();
      return;
    }
    this.deselectAll();
  }

  selectCurrentPage(): void {
    this.dmsTrashBinStore.selectCurrentPage();
  }

  selectAllPages(): void {
    this.dmsTrashBinStore.setCheckAll(true);
  }

  deselectAll(): void {
    this.dmsTrashBinStore.setCheckAll(false);
  }

  menuClosed(reason: string): void {
    if (isNil(reason)) {
      this.valueControl.setValue(false, { emitEvent: false });
    }
  }
}
